import React,{useState,useEffect} from 'react';
import { useTranslation } from 'react-i18next'
import axios from '../../../../plugins/axios';
import Toast from '../../../../plugins/useToast';

import {ReactComponent as IconArrowUp} from '../../../../assets/icons/ic-arrow-up.svg';
import {ReactComponent as IconArrowDown} from '../../../../assets/icons/ic-arrow-down.svg';
import {ReactComponent as IconCheck} from '../../../../assets/icons/ic-check_blue.svg';

const Print = () => {    
    const { t } = useTranslation()
    const [isDisabled, setIsDisabled] = useState(true);    
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const [selectPrintType, setSelectPrintType] = useState({ value : 10, label : t('setting.printOption', { sec: 10, page: 3 }), page : 3})
    const [orignalPrintType, setOrignalPrintType] = useState()
    const [printTypes, ] = useState([
        { value : 10, label : t('setting.printOption', { sec: 10, page: 3 }), page : 3},
        { value : 15, label : t('setting.printOption', { sec: 15, page: 2 }), page : 2},
        { value : 30, label : t('setting.printOption', { sec: 30, page: 1 }), page : 1}
    ])
    
    const getPrintSettings = async () => {
        try {
            const res = await axios.get('/user/me')
            if (res.code != '200') throw res            
            
            //printTypes중에서 value가 res.data.printOutIntervalSeconds인 것을 찾아서 selectPrintType으로 설정
            const foundPrintType = printTypes.find(printType => printType.value === res.data.printOutIntervalSeconds);
            if (foundPrintType) {
                console.log('foundPrintType :', foundPrintType);
                setSelectPrintType(foundPrintType);
                setOrignalPrintType(foundPrintType);
            }            
        } catch (err) {
            console.warn(err);
        }
    };

    // Print settings 저장 버튼 클릭    
    const handleSave = async () => {
        try{            
            const payload = {
                "printOutIntervalSeconds" : selectPrintType.value
            }                        

            const res = await axios.put('/user/me/print/setting', payload);
            if(res.code != '200') throw res;

            Toast({ isSuccess: true, msg: t('setting.printSaveSuccess') });
            setOrignalPrintType(selectPrintType);
        }
        catch(err){
            Toast({ isSuccess: false, msg: t('setting.printSaveFail') });
            console.warn(err);
        }
    }

    useEffect(() => {
        getPrintSettings();
        const handleClickOutside = (event) => {
            if (!event.target.closest(".print-dropdown")) {
                setIsDropdownOpen(null);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [])    

    useEffect(() => {
        if (selectPrintType?.value !== orignalPrintType?.value) {
            setIsDisabled(false);
        }else{
            setIsDisabled(true);
        }
    }, [selectPrintType,orignalPrintType])

    return (
        <div>
            <p className="mb-[16px] text-[18px] font-normal leading-[110%]">{t('setting.printSettings')}</p>
            <div className='flex flex-col gap-[6px]'>
                <p className="text-white font-pretendard text-[14px] font-light leading-[110%] opacity-70">{t('setting.printOutInterval')}</p>
                <div className="relative select-dropdown">
                    <div className="bg-[#383838] text-[#DEDEDE] w-[256px] h-[32px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#4E4E4E]"
                    onClick={(e) => { e.stopPropagation(); setIsDropdownOpen(!isDropdownOpen);}}>
                        <div className="w-[200px]">{selectPrintType.label}</div>
                        <div className="pointer-events-none">
                            {isDropdownOpen ? <IconArrowUp /> : <IconArrowDown />}
                        </div>
                    </div>
                    {isDropdownOpen && (
                        <div className="print-dropdown absolute top-[35px] bg-[#1F1F1F] w-[256px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">                                            
                            {printTypes.map((printType, _) => {
                                return (
                                    <div                                                             
                                        key={`${printType.page}`}
                                        className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                        ${printType.value == selectPrintType.value ? "text-[#3182F7]" : "text-white"}`}                                                            
                                        onClick={() => { setIsDropdownOpen(null); console.log('printType :',printType); setSelectPrintType(printType);}}>
                                        {printType.label}
                                        {printType.value == selectPrintType.value && (
                                            <IconCheck className="w-4 h-4 ml-2" />
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>
            <button className={`w-[88px] h-[28px] absolute top-[-35px] right-[20px] rounded-[6px] 
                    ${isDisabled? 'bg-[#1f1f1f] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                    : 'text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                    active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                disabled={isDisabled}
                onClick={handleSave}
                >{isDisabled ? t('setting.saved') : t('setting.save')}
            </button>
        </div>
    )
}

export default Print;